import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { PageService } from '../../page/services/page.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.css'],
})
export class ClienteComponent implements OnInit, AfterContentChecked {
  @Input() datos: {};
  @Input() isvendedor = false;
  @Output() datoCliente: EventEmitter<any> = new EventEmitter<any>();
  datosClientes: FormGroup = this.fb.group({
    nif: ['', [Validators.required, this.comprobarDato.bind(this)]],
    nifApoderado: '',
    apellido1: ['', [Validators.required]],
    apellido1Apoderado: '',
    apellido2: '',
    apellido2Apoderado: '',
    nombre: '',
    nombreApoderado: '',
    conceptoRepresentacionApoderado: '',
    sexo: ['', [Validators.required]],
    fechaNacimiento: '',
    email: [
      '',
      [
        Validators.minLength(5),
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
        Validators.required,
      ],
    ],
    telefono: ['', [Validators.required, this.comprobarNumero.bind(this)]],
    enviarDocCorreo: '0',
    direcciones: '',
    provincia: ['', [Validators.required]],
    poblacion: ['', [Validators.required]],
    pueblo: '',
    cp: [
      '',
      [Validators.maxLength(5), Validators.minLength(5), Validators.required],
    ],
    tipoVia: ['', [Validators.required]],
    direccion: ['', [Validators.required]],
    direccionnumero: ['', [Validators.required]],
    direccionpiso: '',
    direccionpuerta: '',
    direccionBloque: '',
    direccionEscalera: '',
    direccionCorrespondenciaCliente: '',
    direccionCorrespondenciaClienteNumero: '',
    direccionCorrespondenciaClientePiso: '',
    direccionCorrespondenciaClientePuerta: '',
    direccionCorrespondenciaClienteBloque: '',
    direccionCorrespondenciaClienteEscalera: '',
    direccionCorrespondenciaClienteCP: '',
    direccionCorrespondenciaClientePoblacion: '',
    direccionCorrespondenciaClienteProvincia: '',
  });

  provincias = [];
  provinciasCorresp = [];
  provincia: string;
  provinciaCorresp: string;

  municipios = [];
  municipiosCorresp = [];
  municipio: string;
  municipioCorresp: string;

  direcciones: any[];
  provinciaC: string;
  siglas = [];
  colaborador: string;
  cliente$: Observable<FormGroup>;
  solicitud: string;
  tipoCliente: any;
  isDivVisible = false;
  isDivVisibleC = true;
  ocultar: boolean;
  hoy = new Date();
  calcular: boolean;
  MOBILE_PATTERN = /[0-9\+\-\ ]/;
  esReinicia: boolean;
  esMoves: boolean;

  private clienteOb$ = new BehaviorSubject<FormGroup>(null);
  clienteListener$: Observable<FormGroup> = this.clienteOb$.asObservable();

  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private servicio: PageService,
    private snackbar: MatSnackBar,
    private date: DatePipe,
    private router: Router
  ) {}

  setForm(form: FormGroup): any {
    this.clienteOb$.next(form);
  }

  ngOnInit(): void {
    console.log(this.datos);
    console.log('Entro en el cliente');
    this.colaborador = sessionStorage.getItem('colaborador');
    this.solicitud = sessionStorage.getItem('id');
    this.tipoCliente = sessionStorage.getItem('tipoCliente');
    this.esReinicia=false;
    this.esMoves=false;
    if(sessionStorage.getItem('tipo')=="AYUDA REINICIA")
    {
      this.esReinicia=true;
    }
    if(sessionStorage.getItem('tipo')=="AYUDA MOVES")
      {
        this.esMoves=true;
      }
    this.getSiglas();
    this.getProvincia();
    this.setocultar();
    this.crearFormulario();
    this.setForm(this.datosClientes);
    this.cliente$ = this.clienteListener$.pipe(delay(0));
    console.log('Datos cliente', this.datosClientes);
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get nifNoValido(): any {
    return (
      this.datosClientes.get('nif').invalid &&
      this.datosClientes.get('nif').touched &&
      this.datosClientes.get('nif').hasError('error')
    );
  }

  get denominacionNoValido(): any {
    return (
      this.datosClientes.get('apellido1').invalid &&
      this.datosClientes.get('apellido1').touched
    );
  }

  get cpNoValido(): any {
    return (
      this.datosClientes.get('cp').invalid &&
      this.datosClientes.get('cp').touched
    );
  }

  get direccionNoValido(): any {
    return (
      this.datosClientes.get('direccion').invalid &&
      this.datosClientes.get('direccion').touched
    );
  }

  get numeroNoValido(): any {
    return (
      this.datosClientes.get('direccionnumero').invalid &&
      this.datosClientes.get('direccionnumero').touched
    );
  }

  get cpNoValidoC(): any {
    return (
      this.datosClientes.get('direccionCorrespondenciaClienteCP').invalid &&
      this.datosClientes.get('direccionCorrespondenciaClienteCP').touched
    );
  }

  get telNoValidoC(): any {
    if (
      this.datosClientes.get('telefono').value === null ||
      this.datosClientes.get('telefono').value === undefined
    ) {
      this.datosClientes.controls.telefono.setValue('');
    }
    return (
      this.datosClientes.get('telefono').invalid &&
      this.datosClientes.get('telefono').touched &&
      this.datosClientes.get('telefono').hasError('error')
    );
  }

  get direccionNoValidoC(): any {
    return (
      this.datosClientes.get('direccionCorrespondenciaCliente').invalid &&
      this.datosClientes.get('direccionCorrespondenciaCliente').touched
    );
  }

  get numeroNoValidoC(): any {
    return (
      this.datosClientes.get('direccionCorrespondenciaClienteNumero').invalid &&
      this.datosClientes.get('direccionCorrespondenciaClienteNumero').touched
    );
  }

  get emailNoValidoC(): any {
    return (
      this.datosClientes.get('email').invalid &&
      this.datosClientes.get('email').touched
    );
  }

  crearFormulario(): any {
    if((this.esReinicia || this.esMoves) && this.colaborador=="MOSTRADOR")
    {
      this.datosClientes = this.fb.group({
        nif: ['', [this.comprobarDato.bind(this)]],
        nifApoderado: '',
        apellido1: '',
        apellido1Apoderado: '',
        apellido2: '',
        apellido2Apoderado: '',
        nombre: '',
        nombreApoderado: '',
        conceptoRepresentacionApoderado: '',
        sexo: '',
        fechaNacimiento: '',
        email: [
          '',
          [
            Validators.minLength(5),
            Validators.pattern(
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ),
            Validators.required,
          ],
        ],
        telefono: ['', [this.comprobarNumero.bind(this)]],
        enviarDocCorreo: '0',
        direcciones: '',
        provincia: '',
        poblacion: '',
        pueblo: '',
        cp: [
          '',
          [Validators.minLength(5), Validators.maxLength(5)],
        ],
        tipoVia: '',
        direccion: '',
        direccionnumero: '',
        direccionpiso: '',
        direccionpuerta: '',
        direccionBloque: '',
        direccionEscalera: '',
        direccionCorrespondenciaCliente: '',
        direccionCorrespondenciaClienteNumero: '',
        direccionCorrespondenciaClientePiso: '',
        direccionCorrespondenciaClientePuerta: '',
        direccionCorrespondenciaClienteBloque: '',
        direccionCorrespondenciaClienteEscalera: '',
        direccionCorrespondenciaClienteCP: '',
        direccionCorrespondenciaClientePoblacion: '',
        direccionCorrespondenciaClienteProvincia: '',
      });
    }
    else{
      this.datosClientes = this.fb.group({
        nif: ['', [Validators.required, this.comprobarDato.bind(this)]],
        nifApoderado: '',
        apellido1: ['', [Validators.required]],
        apellido1Apoderado: '',
        apellido2: '',
        apellido2Apoderado: '',
        nombre: '',
        nombreApoderado: '',
        conceptoRepresentacionApoderado: '',
        sexo: ['', [Validators.required]],
        fechaNacimiento: '',
        email: [
          '',
          [
            Validators.minLength(5),
            Validators.pattern(
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ),
            Validators.required,
          ],
        ],
        telefono: ['', [Validators.required, this.comprobarNumero.bind(this)]],
        enviarDocCorreo: '0',
        direcciones: '',
        provincia: ['', [Validators.required]],
        poblacion: ['', [Validators.required]],
        pueblo: '',
        cp: [
          '',
          [Validators.minLength(5), Validators.maxLength(5), Validators.required],
        ],
        tipoVia: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        direccionnumero: ['', [Validators.required]],
        direccionpiso: '',
        direccionpuerta: '',
        direccionBloque: '',
        direccionEscalera: '',
        direccionCorrespondenciaCliente: '',
        direccionCorrespondenciaClienteNumero: '',
        direccionCorrespondenciaClientePiso: '',
        direccionCorrespondenciaClientePuerta: '',
        direccionCorrespondenciaClienteBloque: '',
        direccionCorrespondenciaClienteEscalera: '',
        direccionCorrespondenciaClienteCP: '',
        direccionCorrespondenciaClientePoblacion: '',
        direccionCorrespondenciaClienteProvincia: '',
      }, { validators: [this.poderRequiresEmpresa] });
    }

    this.datosClientes.get('sexo').valueChanges.subscribe((value) => {
      if (value === 'EMPRESA') {
        this.datosClientes
          .get('nombreApoderado')
          .setValidators([Validators.required]);
        this.datosClientes
          .get('apellido1Apoderado')
          .setValidators([Validators.required]);
        this.datosClientes
          .get('nifApoderado')
          .setValidators([Validators.required]);
        this.datosClientes
          .get('conceptoRepresentacionApoderado')
          .setValidators([Validators.required]);
      } else {
        this.datosClientes.get('nombreApoderado').clearValidators();
        this.datosClientes.get('apellido1Apoderado').clearValidators();
        this.datosClientes.get('nifApoderado').clearValidators();
        this.datosClientes
          .get('conceptoRepresentacionApoderado')
          .clearValidators();
      }
      this.datosClientes.get('nombreApoderado').updateValueAndValidity();
      this.datosClientes.get('apellido1Apoderado').updateValueAndValidity();
      this.datosClientes.get('nifApoderado').updateValueAndValidity();
      this.datosClientes
        .get('conceptoRepresentacionApoderado')
        .updateValueAndValidity();
    });
    // Force EMPRESA when Poder is selected for Firma de Documentos
    if (sessionStorage.getItem('tipo') === 'FIRMA DOCUMENTOS' && sessionStorage.getItem('poder') === 'true') {
      this.datosClientes.get('sexo').setValue('EMPRESA');
    }
    if((this.esReinicia || this.esMoves) && this.colaborador=="MOSTRADOR")
    {
      
    }
    if(this.esReinicia || this.esMoves)
    {
      console.log("AÑADIR CAMPOS OBLIGATORIOS REINICIA");
      //this.datosClientes
      //    .get('apellido2')
      //    .setValidators([Validators.required]);
      if(this.colaborador!="MOSTRADOR")
      {
        this.datosClientes
            .get('nombre')
            .setValidators([Validators.required]);
      }
      if(this.colaborador=="MOSTRADOR")
      {
        console.log("QUITAR CAMPOS OBLIGATORIOS AYUDAS");
        this.datosClientes
            .get('sexo')
            .clearValidators();
        this.datosClientes
            .get('nif')
            .clearValidators();
        this.datosClientes
            .get('telefono')
            .clearValidators();
      }
      console.log("QUITAR CAMPOS OBLIGATORIOS REINICIA");
      this.datosClientes
          .get('sexo')
          .clearValidators();
     // this.datosClientes
       //   .get('apellido1')
         // .clearValidators();
      this.datosClientes
          .get('provincia')
          .clearValidators();
      this.datosClientes
          .get('poblacion')
          .clearValidators();
      this.datosClientes
          .get('pueblo')
          .clearValidators();
      this.datosClientes
          .get('cp')
          .clearValidators();
      this.datosClientes
          .get('cp')
          .setValidators([Validators.minLength(5), Validators.maxLength(5)]);
      this.datosClientes
          .get('tipoVia')
          .clearValidators();
      this.datosClientes
          .get('direccion')
          .clearValidators();
      this.datosClientes
          .get('direccionnumero')
          .clearValidators();
    }
  }

  setocultar(): void {
    this.ocultar = this.router.url !== '/page/matriculacion';
    console.log(this.router.url);
  }

  enviar(): any {
    // Validate: Poder requires sexo=EMPRESA with apoderado fields
    if (sessionStorage.getItem('poder') === 'true' && this.datosClientes.get('sexo').value !== 'EMPRESA') {
      Swal.fire('', 'Para el documento Poder, el sexo debe ser EMPRESA y los datos del apoderado son obligatorios.', 'warning');
      return;
    }
    console.log('PROVINCIA CORRESP', this.provinciaCorresp);
    if (this.provincia) {
      this.datosClientes.value.provincia = this.provincia;
    }
    if (this.provinciaCorresp) {
      this.provinciasCorresp.map((p) => {
        if (
          p.idprov.includes(
            this.datosClientes.value.direccionCorrespondenciaClienteProvincia
          ) ||
          p.nomprov.includes(
            this.datosClientes.value.direccionCorrespondenciaClienteProvincia
          )
        ) {
          console.log(
            this.datosClientes.value.direccionCorrespondenciaClienteProvincia
          );
          this.provinciaCorresp = p.nomprov;
          console.log('Provincia corresp', this.provinciaCorresp, p);
        }
      });
      this.datosClientes.value.direccionCorrespondenciaClienteProvincia =
        this.provinciaCorresp;
    }

    this.datosClientes.value.fechaNacimiento = this.date.transform(
      this.datosClientes.value.fechaNacimiento,
      'yyyy-MM-dd'
    );
    delete this.datosClientes.value.direcciones;
    this.datoCliente.emit(this.datosClientes.value);
    console.log('DATOSCLIENTE:', this.datosClientes);
  }

  getProvincia(): void {
    this.servicio.getProvincia().subscribe(
      async (res) => {
        console.log('PROVINCIAS', res);
        this.provincias = await res;
        this.provinciasCorresp = await res;
        if (this.datos && this.solicitud === 'null') {
          console.log('solicitud null y tiene datos');
          console.log(this.datos);
          this.llenarDato(this.datos);
        }

        if (this.datos && this.solicitud !== 'null') {
          console.log('solicitud no null y tiene datos');
          this.Dato(this.datos);
        }

        if (this.solicitud !== 'null' && !this.datos) {
          console.log('solicitud no null y no tiene datos');
          this.getSolicitud();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMunicipio(): any {
    if (this.datosClientes.value.provincia) {
      this.provincias.map((p) => {
        if (p.idprov.includes(this.datosClientes.value.provincia)) {
          this.provincia = p.nomprov;
          console.log('Provincia', this.provincia);
        }
      });
      this.servicio
        .getMuninicipio(this.datosClientes.value.provincia)
        .subscribe(
          async (res) => {
            this.municipios = await res;
          },
          (error) => {
            console.log(error);
          }
        );
    }
    console.log(this.datosClientes);
  }

  getMunicipioCorresp(): any {
    if (this.datosClientes.value.direccionCorrespondenciaClienteProvincia) {
      this.provinciasCorresp.map((p) => {
        if (
          p.idprov.includes(
            this.datosClientes.value.direccionCorrespondenciaClienteProvincia
          )
        ) {
          this.provinciaCorresp = p.nomprov;
          console.log('Provincia Corresps', this.provinciaCorresp);
        }
      });
      this.servicio
        .getMuninicipio(
          this.datosClientes.value.direccionCorrespondenciaClienteProvincia
        )
        .subscribe(
          async (res) => {
            console.log('Municipios corresp', res);
            this.municipiosCorresp = await res;
          },
          (error) => {
            console.log(error);
          }
        );
    }
    console.log(this.datosClientes);
  }

  municipioGet(idprov, dato): any {
    console.log('municipioGet', idprov);
    console.log(this.municipios);
    if (this.municipios.length === 0) {
      this.servicio.getMuninicipio(idprov).subscribe(
        async (res) => {
          this.municipios = await res;
        },
        (error) => {
          console.log(error);
        }
      );
      this.datosClientes.controls.poblacion.setValue(
        dato.poblacion?.toUpperCase().trim()
      );
    }
    this.municipios.map((p) => {
      if (p.cp.includes(idprov)) {
        console.log(dato.poblacion?.toUpperCase().trim());
        this.datosClientes.controls.poblacion.setValue(
          dato.poblacion?.toUpperCase().trim()
        );
      }
    });
  }

  municipioGetCorrespondencia(idprov, dato): any {
    console.log('municipioGet', idprov);
    console.log(this.municipiosCorresp);
    if (this.municipiosCorresp.length === 0) {
      this.servicio.getMuninicipio(idprov).subscribe(
        async (res) => {
          this.municipiosCorresp = await res;
        },
        (error) => {
          console.log(error);
        }
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePoblacion.setValue(
        dato.poblacion?.toUpperCase().trim()
      );
    }
    this.municipiosCorresp.map((p) => {
      if (p.cp.includes(idprov)) {
        console.log(dato.poblacion?.toUpperCase().trim());
        this.datosClientes.controls.direccionCorrespondenciaClientePoblacion.setValue(
          dato.poblacion?.toUpperCase().trim()
        );
      }
    });
  }

  direccionesGet(nif): void {
    console.log('ENTRO EN DIRECCIONESGET');
    if (nif) {
      this.servicio.getDirecciones(nif).subscribe(
        (res) => {
          if (res !== null) {
            this.direcciones = res;
            console.log(res);
            if (this.direcciones.length > 0) {
              console.log('si');
              this.isDivVisible = true;
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  setDatos(datos): void {
    console.log('ENTRO EN LA FUNCION SETDATOS', datos);
    //this.getMunicipio();
    this.datosClientes.controls.nif.setValue(
      datos.nifCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.nifApoderado.setValue(
      datos.nifApoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1.setValue(
      datos.apellido1Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1Apoderado.setValue(
      datos.apellido1Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2.setValue(
      datos.apellido2Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2Apoderado.setValue(
      datos.apellido2Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombre.setValue(
      datos.nombreCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombreApoderado.setValue(
      datos.nombreApoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.conceptoRepresentacionApoderado.setValue(
      datos.conceptorepresentacionApoderado?.toUpperCase().trim()
    );
    const genero = this.getGenero(datos.sexoCliente?.toUpperCase().trim());
    console.log('setDatos:' + datos.nifCliente);
    this.datosClientes.controls.sexo.setValue(genero);
    if (datos.sexoCliente != 'X' && !this.esReinicia) {
      this.datosClientes
        .get('fechaNacimiento')
        .setValidators(Validators.required);
    }
    this.datosClientes.controls.fechaNacimiento.setValue(
      datos.fechanacimientoCliente
    );
    this.datosClientes.controls.email.setValue(
      datos.emailCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.telefono.setValue(
      datos.telefonoCliente?.trim()
    );
    let idProv = 0;
    if (datos.provinciaCliente) {
      this.provincia = datos.provinciaCliente?.toUpperCase().trim();
      console.log(this.provincia);
      this.provincias.map((p) => {
        if (p.nomprov.includes(this.provincia)) {
          idProv = p.idprov;
        }
      });
    }
    this.datosClientes.controls.provincia.setValue(idProv === 0 ? '' : idProv);
    console.log('Municipio', this.municipios);

    this.servicio.getMuninicipio(idProv).subscribe(
      async (res) => {
        this.municipios = await res;
      },
      (error) => {
        console.log(error);
      }
    );
    this.datosClientes.controls.poblacion.setValue(
      datos.poblacionCliente?.toUpperCase().trim()
    );

    this.datosClientes.controls.pueblo.setValue(
      datos.puebloCliente?.toUpperCase().trim()
    );

    if (datos.codigopostalCliente.toString().length === 4) {
      datos.codigopostalCliente.toString().padStart(5, '0');
      this.datosClientes.controls.cp.setValue(datos.codigopostalCliente);
    } else if (datos.codigopostalCliente.toString().length === 5) {
      this.datosClientes.controls.cp.setValue(datos.codigopostalCliente);
    }
    console.log('cp', this.datosClientes.controls.cp.value);

    let codSigla = '';
    this.siglas.map((p) => {
      if (p.codigosigla.includes(datos.siglasCalle)) {
        codSigla =
          p.siglacalle +
          ' - ' +
          p.descripcion.toUpperCase() +
          ' - ' +
          p.codigosigla;
      }
    });
    console.log(codSigla);
    this.datosClientes.controls.tipoVia.setValue(codSigla);
    this.datosClientes.controls.direccion.setValue(
      datos.direccionCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccionnumero.setValue(
      datos.direccionnumeroCliente?.trim()
    );
    this.datosClientes.controls.direccionpuerta.setValue(
      datos.direccionpuertaCliente?.trim()
    );
    this.datosClientes.controls.direccionpiso.setValue(
      datos.direccionpisoCliente?.trim()
    );
    this.datosClientes.controls.direccionBloque.setValue(
      datos.direccionbloqueCliente?.trim()
    );
    this.datosClientes.controls.direccionEscalera.setValue(
      datos.direccionescaleraCliente?.trim()
    );

    this.snackbar.open(
      'Información del cliente autocompletada, por favor, revise los datos.',
      'OK',
      {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'snack-cliente',
        duration: 3500,
      }
    );
  }

  setDato(dato): any {
    console.log('ENTRO EN FUNCION SETDATO', dato);
    this.direccionesGet(dato.nif?.toUpperCase().trim());
    this.datosClientes.controls.nif.setValue(dato.nif?.toUpperCase().trim());
    this.datosClientes.controls.nifApoderado.setValue(
      dato.nifApoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1.setValue(
      dato.apellido1Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1Apoderado.setValue(
      dato.apellido1Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2.setValue(
      dato.apellido2Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2Apoderado.setValue(
      dato.apellido2Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombre.setValue(
      dato.nombreCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombreApoderado.setValue(
      dato.nombreApoderado?.toUpperCase().trim()
    );
    //this.datosClientes.controls.sexo.setValue(dato.sexoCliente?.toUpperCase().trim());
    //console.log("setDato sexo:"+dato.sexo);
    const genero = this.getGenero(dato.sexoCliente?.toUpperCase().trim());
    console.log('Género:' + genero);
    this.datosClientes.controls.sexo.setValue(genero);
    if (dato.sexoCliente != 'X' && !this.esReinicia) {
      this.datosClientes
        .get('fechaNacimiento')
        .setValidators(Validators.required);
    }
    this.datosClientes.controls.fechaNacimiento.setValue(
      dato.fechaNacimientoCliente
    );
    this.datosClientes.controls.email.setValue(
      dato.emailCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.telefono.setValue(dato.telefonoCliente?.trim());
    const enviarDoc = this.getRespuesta(dato.enviarDocCorreo);
    this.datosClientes.controls.enviarDocCorreo.setValue(enviarDoc);
    let idProv = 0;
    if (dato.provincia) {
      this.provincia = dato.provincia?.toUpperCase().trim();
      console.log(this.provincia);
      this.provincias.map((p) => {
        if (p.nomprov.includes(this.provincia)) {
          idProv = p.idprov;
        }
      });
    }
    console.log(idProv);
    this.datosClientes.controls.provincia.setValue(idProv === 0 ? '' : idProv);
    this.getMunicipio();
    this.datosClientes.controls.poblacion.setValue(
      dato.poblacion?.toUpperCase().trim()
    );
    this.datosClientes.controls.pueblo.setValue(
      dato.pueblo?.toUpperCase().trim()
    );
    this.datosClientes.controls.cp.setValue(dato.cp?.trim());
    this.datosClientes.controls.tipoVia.setValue(
      dato.tipoVia?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccion.setValue(
      dato.direccion?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccionnumero.setValue(
      dato.direccionnumero?.trim()
    );
    this.datosClientes.controls.direccionpuerta.setValue(
      dato.direccionpuerta?.trim()
    );
    this.datosClientes.controls.direccionpiso.setValue(
      dato.direccionpiso?.trim()
    );
    this.datosClientes.controls.direccionEscalera.setValue(
      dato.direccionEscalera?.trim()
    );
    this.datosClientes.controls.direccionBloque.setValue(
      dato.direccionBloque?.trim()
    );
  }

  llenarDato(dato): any {
    console.log('llenarDato', dato);
    this.direccionesGet(dato.nif?.toUpperCase().trim());
    this.datosClientes.controls.nif.setValue(
      dato.nifCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1.setValue(
      dato.apellido1Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2.setValue(
      dato.apellido2Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombre.setValue(
      dato.nombreCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.telefono.setValue(dato.telefonoCliente?.trim());
    this.datosClientes.controls.email.setValue(dato.emailCliente?.trim());
    this.datosClientes.controls.conceptoRepresentacionApoderado.setValue(
      dato.conceptorepresentacionApoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.nifApoderado.setValue(
      dato.nifApoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido1Apoderado.setValue(
      dato.apellido1Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.apellido2Apoderado.setValue(
      dato.apellido2Apoderado?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombreApoderado.setValue(
      dato.nombreApoderado.toUpperCase().trim()
    );

    let idProv = 0;
    if (dato.provinciaCliente) {
      this.provincia = dato.provinciaCliente?.toUpperCase().trim();
      console.log(dato.provincia);
      this.provincias.map((p) => {
        if (p.nomprov.includes(this.provincia)) {
          idProv = p.idprov;
        }
      });
    }
    this.datosClientes.controls.provincia.setValue(idProv === 0 ? '' : idProv);
    this.getMunicipio();
    this.datosClientes.controls.poblacion.setValue(
      dato.poblacionCliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.pueblo.setValue(
      dato.puebloCliente?.toUpperCase().trim()
    );
    if (dato.codigopostalCliente.toString().length === 5) {
      this.datosClientes.controls.cp.setValue(dato.codigopostalCliente);
    }
    if (dato.codigopostalCliente.toString().length === 4) {
      dato.codigopostalCliente.toString().padStart(5, '0');
      this.datosClientes.controls.cp.setValue(dato.codigopostalCliente);
    } else if (dato.codigopostalCliente.toString().length === 5) {
      this.datosClientes.controls.cp.setValue(dato.codigopostalCliente);
    }
    let codSigla = '';
    this.siglas.map((p) => {
      if (p.codigosigla.includes(dato.siglasCalle)) {
        codSigla =
          p.siglacalle +
          ' - ' +
          p.descripcion.toUpperCase() +
          ' - ' +
          p.codigosigla;
      }
    });
    console.log('CodSigla', codSigla);
    this.datosClientes.controls.tipoVia.setValue(codSigla);
    this.datosClientes.controls.direccion.setValue(
      dato.direccionCliente?.trim()
    );
    this.datosClientes.controls.direccionnumero.setValue(
      dato.direccionnumeroCliente?.trim()
    );
    this.datosClientes.controls.direccionpiso.setValue(
      dato.direccionpisoCliente?.trim()
    );
    this.datosClientes.controls.direccionpuerta.setValue(
      dato.direccionpuertaCliente?.trim()
    );
    this.datosClientes.controls.direccionBloque.setValue(
      dato.direccionbloqueCliente?.trim()
    );
    this.datosClientes.controls.direccionEscalera.setValue(
      dato.direccionescaleraCliente?.trim()
    );
    //this.datosClientes.controls.sexo.setValue(dato.sexoCliente?.toUpperCase().trim());
    const genero = this.getGenero(dato.sexoCliente?.toUpperCase().trim());
    console.log('llenarDato Género:' + genero);
    this.datosClientes.controls.sexo.setValue(genero);
    if (dato.sexoCliente != 'X' && !this.esReinicia) {
      this.datosClientes
        .get('fechaNacimiento')
        .setValidators(Validators.required);
    }
    console.log('llenarDato:');
    console.log(dato);
    console.log('FIN llenarDato:');
  }

  cargarDirecciones(correspondecia: boolean): void {
    console.log(this.datosClientes.value.direcciones);
    if (this.datosClientes.value.direcciones) {
      this.servicio
        .getDireccion(this.datosClientes.value.direcciones)
        .subscribe(
          (res) => {
            console.log(res);
            if (correspondecia) {
              this.setDireccionC(res[0]);
            } else {
              this.setDireccion(res[0]);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  setDireccion(dato): any {
    console.log('DATO NORMAL', dato);
    let idProv = 0;
    this.provincia = dato.provincia?.toUpperCase().trim();
    console.log(dato.provincia);
    this.provincias.map((p) => {
      if (p.nomprov.includes(this.provincia) && this.provincia !== '') {
        idProv = p.idprov;
        console.log(p.idprov);
      }
    });
    this.datosClientes.controls.provincia.setValue(idProv);
    this.municipioGet(idProv, dato);
    this.datosClientes.controls.pueblo.setValue(dato.pueblo?.trim());
    this.datosClientes.controls.cp.setValue(dato.cp?.trim());
    this.datosClientes.controls.tipoVia.setValue(
      dato.tipoVia?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccion.setValue(
      dato.direccion?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccionnumero.setValue(dato.numero?.trim());
    this.datosClientes.controls.direccionpiso.setValue(dato.piso?.trim());
    this.datosClientes.controls.direccionpuerta.setValue(dato.puerta?.trim());
    this.datosClientes.controls.direccionBloque.setValue(dato.bloque?.trim());
    this.datosClientes.controls.direccionEscalera.setValue(
      dato.escalera?.trim()
    );
  }

  setDireccionC(dato): any {
    console.log('DATO CORRESP', dato);
    let idProv = 0;
    this.provinciaC = dato.provincia?.toUpperCase().trim();
    console.log(dato.provincia);
    this.provincias.map((p) => {
      if (p.nomprov.includes(this.provinciaC) && this.provinciaC !== '') {
        idProv = p.idprov;
        console.log(p.idprov);
        this.provinciaCorresp = p.idprov;
      }
    });
    console.log('idProv', idProv);
    this.datosClientes.controls.direccionCorrespondenciaClienteProvincia.setValue(
      idProv
    );
    this.municipioGetCorrespondencia(idProv, dato);

    this.datosClientes.controls.direccionCorrespondenciaClienteCP.setValue(
      dato.cp?.trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaCliente.setValue(
      dato.direccion?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaClienteNumero.setValue(
      dato.numero?.trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaClientePiso.setValue(
      dato.piso?.trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaClientePuerta.setValue(
      dato.puerta?.trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaClienteBloque.setValue(
      dato.bloque?.trim()
    );
    this.datosClientes.controls.direccionCorrespondenciaClienteEscalera.setValue(
      dato.escalera?.trim()
    );
    //this.datosClientes.controls.direccionCorrespondenciaClientePoblacion.setValue(dato.poblacion?.trim());
    console.log(this.provinciaCorresp);
  }

  Dato(dato): void {
    console.log('FUNCION DATO', dato);
    this.direccionesGet(dato.nif?.toUpperCase().trim());
    this.datosClientes.controls.nif.setValue(dato.nif?.toUpperCase().trim());
    this.datosClientes.controls.apellido1.setValue(
      dato.apellido1Cliente?.toUpperCase().trim()
    );

    this.datosClientes.controls.apellido2.setValue(
      dato.apellido2Cliente?.toUpperCase().trim()
    );
    this.datosClientes.controls.nombre.setValue(
      dato.nombreCliente?.toUpperCase().trim()
    );
    //this.datosClientes.controls.sexo.setValue(dato.sexoCliente?.toUpperCase().trim());
    const genero = this.getGenero(dato.sexoCliente?.toUpperCase().trim());
    console.log('Dato:' + genero);
    this.datosClientes.controls.sexo.setValue(genero);
    if (dato.sexoCliente != 'X' && !this.esReinicia) {
      this.datosClientes
        .get('fechaNacimiento')
        .setValidators(Validators.required);
    }
    this.datosClientes.controls.fechaNacimiento.setValue(
      dato.fechaNacimientoCliente
    );
    this.datosClientes.controls.email.setValue(dato.emailCliente?.trim());
    this.datosClientes.controls.telefono.setValue(dato.telefonoCliente?.trim());
    const enviarDoc = this.getRespuesta(dato.enviarDocCorreo);
    this.datosClientes.controls.enviarDocCorreo.setValue(enviarDoc);
    let idProv = 0;
    if (dato.provincia) {
      this.provincia = dato.provincia?.toUpperCase().trim();
      this.provincias.map((p) => {
        if (p.nomprov.includes(this.provincia)) {
          idProv = p.idprov;
        }
      });
    }
    this.datosClientes.controls.provincia.setValue(idProv === 0 ? '' : idProv);
    console.log(this.datosClientes.value.provincia, 'carga provincia');
    this.getMunicipio();
    this.datosClientes.controls.poblacion.setValue(
      dato.poblacion?.toUpperCase().trim()
    );
    this.datosClientes.controls.pueblo.setValue(
      dato.pueblo?.toUpperCase().trim()
    );
    this.datosClientes.controls.cp.setValue(dato.cp);
    // tslint:disable-next-line:max-line-length
    this.datosClientes.controls.tipoVia.setValue(
      dato.tipoVia?.toUpperCase().trim()
    );
    this.datosClientes.controls.direccion.setValue(dato.direccion?.trim());
    this.datosClientes.controls.direccionnumero.setValue(
      dato.direccionnumero?.trim()
    );
    this.datosClientes.controls.direccionpiso.setValue(
      dato.direccionpiso?.trim()
    );
    this.datosClientes.controls.direccionpuerta.setValue(
      dato.direccionpuerta?.trim()
    );
    this.datosClientes.controls.direccionBloque.setValue(
      dato.direccionBloque?.trim()
    );
    this.datosClientes.controls.direccionEscalera.setValue(
      dato.direccionEscalera?.trim()
    );
  }

  setSameDirection($event: MatCheckboxChange): void {
    console.log(this.datosClientes);
    console.log($event);
    if ($event.checked) {
      this.isDivVisibleC = false;
      this.datosClientes.controls.direccionCorrespondenciaClienteProvincia.setValue(
        this.datosClientes.value.provincia
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePoblacion.setValue(
        this.datosClientes.value.poblacion
      );
      this.provinciaCorresp = this.datosClientes.value.provincia;

      this.datosClientes.controls.direccionCorrespondenciaClienteCP.setValue(
        this.datosClientes.value.cp
      );
      this.datosClientes.controls.direccionCorrespondenciaCliente.setValue(
        this.datosClientes.value.direccion
      );
      this.datosClientes.controls.direccionCorrespondenciaClienteNumero.setValue(
        this.datosClientes.value.direccionnumero
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePiso.setValue(
        this.datosClientes.value.direccionpiso
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePuerta.setValue(
        this.datosClientes.value.direccionpuerta
      );
      this.datosClientes.controls.direccionCorrespondenciaClienteBloque.setValue(
        this.datosClientes.value.direccionBloque
      );
      this.datosClientes.controls.direccionCorrespondenciaClienteEscalera.setValue(
        this.datosClientes.value.direccionEscalera
      );
    } else {
      this.provinciaCorresp = '';
      this.isDivVisibleC = true;
      this.datosClientes.controls.direccionCorrespondenciaClienteProvincia.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePoblacion.setValue(
        ''
      );

      this.datosClientes.controls.direccionCorrespondenciaClienteCP.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaCliente.setValue('');
      this.datosClientes.controls.direccionCorrespondenciaClienteNumero.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePiso.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaClientePuerta.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaClienteBloque.setValue(
        ''
      );
      this.datosClientes.controls.direccionCorrespondenciaClienteEscalera.setValue(
        ''
      );
    }
    console.log(this.datosClientes.controls);
  }

  comprobarNumero(control: FormControl) {
    const numero = /^[0-9]{9}$/;
    const str = control.value;
    /*console.log(str);
    console.log(numero.test(str));*/
    if (numero.test(str)) {
      return null;
    } else {
      return { error: { str: true } };
    }
  }

  getSiglas(): any {
    this.servicio.getSiglas().subscribe(
      async (res) => {
        console.log('Siglas', res);
        this.siglas = await res;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCliente(): void {
    if (!isNaN(this.datosClientes.get('nif').value.charAt(0))) {
      if (
        this.datosClientes.value.nif.length > 0 &&
        this.datosClientes.value.nif.length < 8
      ) {
        this.calcular = true;
      }
      if (this.calcular) {
        this.letra(this.datosClientes.value.nif);
      }
    }
    this.servicio
      .getCliente(this.datosClientes.get('nif').value)
      .subscribe((res) => {
        if (res !== null) {
          this.setDatos(res);
        } else {
          this.datosClientes.patchValue({
            nif: this.datosClientes.value.nif?.toUpperCase().trim(),
            nifApoderado: '',
            apellido1: '',
            apellido1Apoderado: '',
            apellido2: '',
            apellido2Apoderado: '',
            nombre: '',
            nombreApoderado: '',
            conceptoRepresentacionApoderado: '',
            sexo: '',
            fechaNacimiento: '',
            email: '',
            telefono: '',
            enviarDocCorreo: '0',
            direcciones: '',
            provincia: '',
            poblacion: '',
            pueblo: '',
            cp: '',
            tipoVia: '',
            direccion: '',
            direccionnumero: '',
            direccionpiso: '',
            direccionpuerta: '',
            direccionBloque: '',
            direccionEscalera: '',
          });
        }
        this.municipios = [];
      });
    this.direccionesGet(this.datosClientes.get('nif').value);
  }

  letra(dni): void {
    if (dni.length === 8 && !isNaN(dni)) {
      const cadena = [
        'T',
        'R',
        'W',
        'A',
        'G',
        'M',
        'Y',
        'F',
        'P',
        'D',
        'X',
        'B',
        'N',
        'J',
        'Z',
        'S',
        'Q',
        'V',
        'H',
        'L',
        'C',
        'K',
        'E',
        'T',
      ];
      const posicion = dni % 23;
      this.datosClientes.controls.nif.setValue(dni + cadena[posicion]);
      this.calcular = false;
    }
  }

  letraApoderado(dni): void {
    if (dni.length === 8 && !isNaN(dni)) {
      const cadena = [
        'T',
        'R',
        'W',
        'A',
        'G',
        'M',
        'Y',
        'F',
        'P',
        'D',
        'X',
        'B',
        'N',
        'J',
        'Z',
        'S',
        'Q',
        'V',
        'H',
        'L',
        'C',
        'K',
        'E',
        'T',
      ];
      const posicion = dni % 23;
      this.datosClientes.controls.nifApoderado.setValue(dni + cadena[posicion]);
      this.calcular = false;
    }
  }

  getSolicitud(): any {
    this.servicio.getOneSolicitud(this.solicitud).subscribe(
      (res) => {
        console.log(res);
        this.setDato(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getGenero(condition): string {
    let genero = '';
    switch (condition) {
      case 'X':
        genero = 'EMPRESA';
        break;
      case 'H':
        genero = 'MUJER';
        break;
      case 'V':
        genero = 'HOMBRE';
        break;
    }
    return genero;
  }

  getRespuesta(condition): string {
    let v = '';
    switch (condition) {
      case false:
        v = '0';
        break;
      case true:
        v = '1';
        break;
    }
    return v;
  }

  comprobarDato(control: FormControl): any {
    const DNI_REGEX = /^(\d{8})([A-Z])$/;
    const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
    const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
    const str = control.value;
    /*console.log(str);
    console.log(DNI_REGEX.test(str));
    console.log(CIF_REGEX.test(str));
    console.log(NIE_REGEX.test(str));*/
    if (DNI_REGEX.test(str) || CIF_REGEX.test(str) || NIE_REGEX.test(str)) {
      return null;
    } else {
      return { error: { str: true } };
    }
  }

  check(): boolean {
    return !(
      this.datosClientes.value.cp !== '' &&
      this.datosClientes.value.provincia !== '' &&
      this.datosClientes.value.municipio !== '' &&
      this.datosClientes.value.direccion !== '' &&
      this.datosClientes.value.direccionnumero !== ''
    );
  }

  getApoderado(): void {
    if (!isNaN(this.datosClientes.get('nifApoderado').value.charAt(0))) {
      if (
        this.datosClientes.value.nifApoderado.length > 0 &&
        this.datosClientes.value.nifApoderado.length < 8
      ) {
        this.calcular = true;
      }
      if (this.calcular) {
        this.letraApoderado(this.datosClientes.value.nifApoderado);
      }
    }
    this.servicio
      .getApoderado(this.datosClientes.get('nifApoderado').value)
      .subscribe((res) => {
        if (res !== null) {
          console.log(res);
          this.datosClientes.patchValue({
            nifApoderado: this.datosClientes.value.nifApoderado
              ?.toUpperCase()
              .trim(),
            apellido1Apoderado: res.apellido1Apoderado?.toUpperCase().trim(),
            apellido2Apoderado: res.apellido2Apoderado?.toUpperCase().trim(),
            nombreApoderado: res.nombreApoderado?.toUpperCase().trim(),
          });
        } else {
          this.datosClientes.patchValue({
            nifApoderado: this.datosClientes.value.nifApoderado
              ?.toUpperCase()
              .trim(),
            apellido1Apoderado: '',
            apellido2Apoderado: '',
            nombreApoderado: '',
          });
        }
      });
  }

  poderRequiresEmpresa(group: AbstractControl): ValidationErrors | null {
    if (sessionStorage.getItem('tipo') === 'FIRMA DOCUMENTOS'
        && sessionStorage.getItem('poder') === 'true'
        && group.get('sexo').value !== 'EMPRESA') {
      return { poderRequiresEmpresa: true };
    }
    return null;
  }

  setRequiredColaborador(): void {
    //console.log("SETREQUIREDCOLABORADOR");

    if(this.esReinicia || this.esMoves)
    {
      if (this.datosClientes.get('sexo').value != 'EMPRESA') {
        //console.log("NO ES EMPRESA");
        this.datosClientes.get('nombre').setValidators(Validators.required);
        /*this.datosClientes
          .get('fechaNacimiento')
          .setValidators(Validators.required);*/
      } else {
        //console.log("ES EMPRESA");
        this.datosClientes.get('nombre').clearValidators();
        this.datosClientes.get('fechaNacimiento').clearValidators();
        this.datosClientes.get('apellido2').clearValidators();
        this.datosClientes
          .get('conceptoRepresentacionApoderado')
          .clearValidators();
        this.datosClientes
          .get('nombreApoderado')
          .clearValidators();
        this.datosClientes
          .get('apellido1Apoderado')
          .clearValidators();
        this.datosClientes
          .get('nifApoderado')
          .clearValidators();
      }
      this.datosClientes.get('nombre').updateValueAndValidity();
      this.datosClientes.get('fechaNacimiento').updateValueAndValidity();
      this.datosClientes.get('apellido2').updateValueAndValidity();
      this.datosClientes
          .get('conceptoRepresentacionApoderado')
          .updateValueAndValidity();
      this.datosClientes
        .get('nombreApoderado')
        .updateValueAndValidity();
      this.datosClientes
        .get('apellido1Apoderado')
        .updateValueAndValidity();
      this.datosClientes
        .get('nifApoderado')
        .updateValueAndValidity();
    }
    else
    {
      if (this.datosClientes.get('sexo').value != 'EMPRESA') {
        //console.log("NO ES EMPRESA");
        this.datosClientes.get('nombre').setValidators(Validators.required);
        this.datosClientes
          .get('fechaNacimiento')
          .setValidators(Validators.required);
      } else {
        //console.log("ES EMPRESA");
        this.datosClientes.get('nombre').clearValidators();
        this.datosClientes.get('fechaNacimiento').clearValidators();
      }
      this.datosClientes.get('nombre').updateValueAndValidity();
      this.datosClientes.get('fechaNacimiento').updateValueAndValidity();
    }
  }
}
